import { postRequest } from 'services/requests';

const services = {
    signin: (body) => postRequest('/auth/sign-in', body),
    createInstructors: (body) => postRequest(`/admin/create-instructors`, body),
    findCourse: (body) => postRequest(`/admin/find-course`, body),
    findUser: (body) => postRequest(`/admin/find-user`, body),
    listUsers: (body) => postRequest(`/admin/list-users`, body),
    listStudents: (body) => postRequest(`/admin/list-students`, body),
    updateUser: (body) => postRequest(`/admin/update-user`, body),
    studentDeactivate: (body) => postRequest(`/admin/student-deactivate`, body),
    studentActivate: (body) => postRequest(`/admin/student-activate`, body),
    selectAccount: (body) => postRequest(`/auth/select-account`, body),
    unselectAccount: () => postRequest(`/auth/unselect-account`),
    forgotPassword: (body) => postRequest(`/auth/forgot-password`, body),
    changePassword: (body) => postRequest(`/auth/change-password`, body),
    sendForgotPassword: (body) => postRequest('/auth/forgot-password', body),
    signUp: (body) => postRequest('/auth/sign-up', body),
};

export default services;
